
















import {Component, Vue} from "vue-property-decorator";
import DashboardItem from "./DashboardItem.vue";
import IDashboardItemDefinition from "@/auxillary/IDashboardItemDefinition";

import {
  auditTrailModule, instituteWithStudySystemModule,
  pseudonymizedPatientModule,
  realPatientModule,
  rolesModule,
  studySystemModule,
  usersModule
} from "@/store";

@Component({
  components: {DashboardItem}
})
export default class Dashboard extends Vue {
  items: Array<IDashboardItemDefinition> = [];

  async getItems(): Promise<Array<IDashboardItemDefinition>> {
    return [
      {
        title: "Nutzer und Rollen",
        text: await this.getUsersTextAsync(),
        icon: "fa-user-cog",
        route: "admin/usersadmin"
      },
      {
        title: "Zentren",
        text: await this.getInstitutesTextAsync(),
        icon: "fa-hospital",
        route: "institutes"
      },
      {
        title: "Studien",
        text: await this.getStudySystemsTextAsync(),
        icon: "fa-notes-medical",
        route: "studysystems"
      },
      {
        title: "Patienten",
        text: await this.getPatientTextAsync(),
        icon: "fa-user-injured",
        route: "realpatients"
      },
      {
        title: "Patienten-Consents",
        text: await this.getPatientConsentTextAsync(),
        icon: "fa-clipboard-check",
        route: "patientconsents"
      },
      {
        title: "Pseudonymisierte Patienten",
        text: await this.getPseudonymizedPatientTextAsync(),
        icon: "fa-user-secret",
        route: "pseudonymizedpatients"
      },
      {
        title: "AuditTrail",
        text: await this.getAuditTrailTextAsync(),
        icon: "fa-list",
        route: "admin/audittrail"
      }];
  }

  async getInstitutesTextAsync() {
    const count = await instituteWithStudySystemModule.countAsync();
    return count + " Zentr" + (count !== 1 ? "en" : "um") + " registriert";
  }

  async getPatientTextAsync() {
    const count = await realPatientModule.countAsync();
    return count + " Patient" + (count !== 1 ? "en" : "") + " registriert";
  }

  async getPatientConsentTextAsync() {
    const count = await realPatientModule.countAsync();
    return count + " Patient-Consent" + (count !== 1 ? "s" : "") + " registriert";
  }

  async getPseudonymizedPatientTextAsync() {
    const count = await pseudonymizedPatientModule.countAsync();
    return count + " Pseudonymisierte" + (count == 1 ? "r" : "") + " Patient" + (count !== 1 ? "en" : "") + " registriert";
  }

  async getUsersTextAsync() {
    const usersCount = await usersModule.countAsync();
    const rolesCount = await rolesModule.countAsync();
    return usersCount + " Benutzer registriert, "
        + rolesCount + " Rolle" + (rolesCount !== 1 ? "n" : "") + " registriert";
  }

  async getStudySystemsTextAsync() {
    const count = await studySystemModule.countAsync();
    return count + " Studie" + (count == 1 ? "" : "n") + " registriert";
  }

  async getAuditTrailTextAsync() {
    const count = await auditTrailModule.countAsync();
    return count + " AuditTrail-Einträge";
  }

  show(view: string) {
    this.$router.push(view);
  }

  async mounted() {
    this.items = await this.getItems();
  }
}
